<div class="modal-header">
  <h1 class="modal-title float-start">{{ "collections.modal.title" | translate }}</h1>

  <button
    type="button"
    class="btn-close float-end"
    [attr.aria-label]="'forms.common.close' | translate"
    (click)="bsModalRef.hide()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="newCollectionForm" (ngSubmit)="onCreateCollectionSubmit()">
    <h2>{{ "collections.modal.createCollection.title" | translate }}</h2>

    <div class="form-group">
      <label for="name">{{ "collections.modal.createCollection.name.label" | translate }}</label>

      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="name"
          formControlName="name"
          [placeholder]="'collections.modal.createCollection.name.placeholder' | translate"
          [ngClass]="{ 'is-invalid': newCollectionSubmitted && nameCtrl.errors }" />

        <button type="submit" class="btn btn-blue">{{ "forms.common.save" | translate }}</button>

        @if (nameCtrl.errors) {
          <div class="invalid-feedback">
            @if (nameCtrl.errors.required) {
              <div>{{ "forms.common.required" | translate }}</div>
            }
          </div>
        }
      </div>
    </div>
  </form>

  @if (userCollections?.length > 0) {
    <form (ngSubmit)="onAddToCollectionSubmit()">
      <h2>{{ "collections.modal.addToCollection.title" | translate }}</h2>
      <div class="form-group">
        @for (collection of userCollections; track collection) {
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              [id]="collection.id"
              (change)="onCollectionIdChange($event, collection.id)"
              [checked]="selectedCollections.includes(+collection.id)" />
            <label class="form-check-label" [for]="collection.id">{{ collection.name }}</label>
          </div>
        }
      </div>
      <button type="submit" class="btn btn-blue">{{ "forms.common.add" | translate }}</button>
    </form>
  }
</div>
